<template>
<el-radio-group v-model="concType" size="small" @change="onSelectChanged">
  <el-radio-button v-if="lineChart" :label="0">势趋</el-radio-button>
  <el-radio-button :label="1">浓度——堆积</el-radio-button>
  <el-radio-button :label="2">浓度——百分比</el-radio-button>
</el-radio-group>
</template>

<script>
export default {
  name: 'ConcType',
  props: {
    defaultConcType: {
      type: Number,
      default: 1
    },
    lineChart: {
      type: Boolean
    }
  },
  data () {
    return {
      concType: this.defaultConcType
    }
  },
  methods: {
    onSelectChanged (concType) {
      this.$emit('update:defaultConcType', concType)
      this.$emit('change', concType)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Data/ConcType.vue